const SHORT_HASH_LEN = 8

export const GIT_SHA =
  import.meta.env.VITE_APP_GIT_SHA?.slice(0, SHORT_HASH_LEN) ?? ''
